import { all, fork } from 'redux-saga/effects';
import { appTokenSaga } from './appToken/appTokenIndex';
import { rootDetectionSaga } from './rootDetection/rootDetectionIndex';
import { loyaltyProgramSaga } from './loyalty/program/loyaltyProgramIndex';
import { loyaltyNotificationsSaga } from './loyalty/notifications/loyaltyNotificationsIndex';
import { loyaltyToastSaga } from './loyalty/toast/loyaltyToastIndex';
import { loyaltyMembersSaga } from './loyalty/members/loyaltyMembersIndex';
import { loyaltyRewardsSaga } from './loyalty/rewards/loyaltyRewardsIndex';
import { loyaltyAutomatedRewardsSaga } from './loyalty/automatedRewards/loyaltyAutomatedRewardsIndex';
import { productCatalogSaga } from './productCatalog/productCatalogSaga';
import { displaySaga } from './display/display/displayIndex';
import { mediaLibrarySaga } from './display/mediaLibrary/mediaLibraryIndex';
import { playlistSaga } from './display/playlist/playlistIndex';
import { clickHouseSaga } from './reports/clickHouse/clickHouseIndex';
import { ReportsChatbotSaga } from './reports/ReportsChatbot/ReportsChatbotIndex';
import { ProductCatalogChatbotSaga } from './productCatalog/ProductCatalogChatbot/ProductCatalogChatbotIndex';
import { reservationReportSaga } from './reports/reservationReport/reservationReportIndex';
import { offersReportSaga } from './reports/offersReport/offersReportIndex';
import { eodClickhouseSaga } from './reports/EODClickhouse/eodClickhouseIndex';
import { voiceAgentSaga } from './reports/voiceAgent/voiceAgentIndex';
import { customersReportSaga } from './reports/customersReport/customersReportIndex';
import { serverInfoSaga } from './serverInfo/serverInfoIndex';
import { offerManagementSaga } from './offers/offerSaga';
import { cateringSaga } from './catering/cateringSaga';

export default function* rootSaga() {
  yield all([
    fork(appTokenSaga),
    fork(rootDetectionSaga),
    fork(loyaltyProgramSaga),
    fork(loyaltyNotificationsSaga),
    fork(loyaltyToastSaga),
    fork(loyaltyMembersSaga),
    fork(loyaltyRewardsSaga),
    fork(loyaltyAutomatedRewardsSaga),
    fork(productCatalogSaga),
    fork(displaySaga),
    fork(offersReportSaga),
    fork(clickHouseSaga),
    fork(ReportsChatbotSaga),
    fork(ProductCatalogChatbotSaga),
    fork(reservationReportSaga),
    fork(eodClickhouseSaga),
    fork(voiceAgentSaga),
    fork(serverInfoSaga),
    fork(offerManagementSaga),
    fork(mediaLibrarySaga),
    fork(playlistSaga),
    fork(cateringSaga),
    fork(customersReportSaga),
  ]);
}
